import { useEffect, useState } from "react";
import * as Yup from 'yup';
import { toast } from "react-toastify";

import { ListUsers, NewUserModalForm } from "../../component";
import Api from "../../Api";

const FindCustomer = () => {
  const api = Api();
  const [customersList, setCustomersList] = useState([]);
  const [customersListCount, setCustomersListCount] = useState(0);
  const [customersListPageIndex, setCustomersListPageIndex] = useState(0);
  const [customersListPageSize, setCustomersListPageSize] = useState(10);
  const initialState = {
    userId: 0,
    fullName: '',
    email: '',
    mobile: '',
    countryCode: '+91',
  }
  const [findOptions, setFindOptions] = useState(initialState);

  const onChangePageIndex = (pageNumber: number) => setCustomersListPageIndex((pageNumber - 1));
  const onChangePageSize = (pageSize: number) => setCustomersListPageSize(pageSize);
  const resetFindOptions = () => setFindOptions(initialState);
  const handleFindCustomer = (findOptions: any) => setFindOptions(findOptions);

  const UserValidationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required('First Name is required'),
    lastName: Yup.string()
      .required('Last Name is required'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    countryCode: Yup.string()
      .matches(/^\+\d{1,3}$/, 'Invalid country code')
      .required('Country code is required'),
    mobile: Yup.string()
      .matches(/^\d{10,15}$/, 'Invalid mobile number')
      .required('Mobile number is required'),
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .required('Password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'Passwords must match')
      .required('Confirm Password is required'),
  });

  const handleCreateCustomer = (customerDetails: any) => {
    api.user.createCustomer(customerDetails)
      .then((response: any) => {
        toast.success(response.result.message);
        searchCustomer({
          ...findOptions,
          pageIndex: customersListPageIndex,
          pageSize: customersListPageSize,
        });
      })
  };
  const handleToggleActivation = (userId: number, userInfo: any) => {
    api.user.updateUserDetails(userId, userInfo)
      .then((response: any) => {
        toast.success(response.result.message);
        searchCustomer({
          ...findOptions,
          pageIndex: customersListPageIndex,
          pageSize: customersListPageSize,
        });
      })
  };
  const handleDeleteCustomer = (userId: number) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      api.user.deleteUser(userId)
        .then((response: any) => {
          toast.success(response.result.message);
          searchCustomer({
            ...findOptions,
            pageIndex: customersListPageIndex,
            pageSize: customersListPageSize,
          });
        })
        .catch((err: any) => {
          toast.error(err.response?.data?.message || "Failed to delete user");
        });
    }
  };
  const searchCustomer = (findOptions: any) => {
    api.user.searchCustomer(findOptions)
      .then((response: any) => {
        const data = response.result.data;
        setCustomersList(data.usersList);
        setCustomersListCount(data.usersListCount);
      })
  };

  useEffect(() => {
    searchCustomer({
      ...findOptions,
      pageIndex: customersListPageIndex,
      pageSize: customersListPageSize
    });
  }, [customersListPageIndex, customersListPageSize, findOptions]);

  return (<>
    <NewUserModalForm
      buttonLabel="Create New Customer"
      UserValidationSchema={UserValidationSchema}
      onCreateNewUser={handleCreateCustomer}
    />
    <ListUsers
      usersList={customersList}
      usersListCount={customersListCount}
      usersListPageIndex={customersListPageIndex}
      usersListPageSize={customersListPageSize}
      onChangePageIndex={onChangePageIndex}
      onChangePageSize={onChangePageSize}
      findOptions={findOptions}
      resetFindOptions={resetFindOptions}
      handleFindUser={handleFindCustomer}
      toggleActivation={handleToggleActivation}
      onDeleteUser={handleDeleteCustomer}
    />
  </>);
};

export default FindCustomer;
